import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

export const StateMessageWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StateMessageContent = styled.div`
  white-space: pre-line;
  margin-top: ${theme.spacing['spacing-5']};
  > * {
    :nth-child(2) {
      margin-top: ${theme.spacing['spacing-3']};
    }
  }
`;

export const StateMessageContenButton = styled.div`
  margin-top: ${theme.spacing['spacing-6']};
`;
